// Fetch all cancellations
export const FETCH_ALL_CANCELLATIONS_REQUEST = "FETCH_ALL_CANCELLATIONS_REQUEST";
export const FETCH_ALL_CANCELLATIONS_SUCCESS = "FETCH_ALL_CANCELLATIONS_SUCCESS";
export const FETCH_ALL_CANCELLATIONS_FAILURE = "FETCH_ALL_CANCELLATIONS_FAILURE";

// Fetch provider-specific cancellations
export const FETCH_PROVIDER_CANCELLATIONS_REQUEST = "FETCH_PROVIDER_CANCELLATIONS_REQUEST";
export const FETCH_PROVIDER_CANCELLATIONS_SUCCESS = "FETCH_PROVIDER_CANCELLATIONS_SUCCESS";
export const FETCH_PROVIDER_CANCELLATIONS_FAILURE = "FETCH_PROVIDER_CANCELLATIONS_FAILURE";

// Apply fine to provider
export const APPLY_CANCELLATION_FINE_REQUEST = "APPLY_CANCELLATION_FINE_REQUEST";
export const APPLY_CANCELLATION_FINE_SUCCESS = "APPLY_CANCELLATION_FINE_SUCCESS";
export const APPLY_CANCELLATION_FINE_FAILURE = "APPLY_CANCELLATION_FINE_FAILURE";

// Update cancellation status
export const UPDATE_CANCELLATION_STATUS_REQUEST = "UPDATE_CANCELLATION_STATUS_REQUEST";
export const UPDATE_CANCELLATION_STATUS_SUCCESS = "UPDATE_CANCELLATION_STATUS_SUCCESS";
export const UPDATE_CANCELLATION_STATUS_FAILURE = "UPDATE_CANCELLATION_STATUS_FAILURE";

// Fetch cancellation statistics
export const FETCH_CANCELLATION_STATISTICS_REQUEST = "FETCH_CANCELLATION_STATISTICS_REQUEST";
export const FETCH_CANCELLATION_STATISTICS_SUCCESS = "FETCH_CANCELLATION_STATISTICS_SUCCESS";
export const FETCH_CANCELLATION_STATISTICS_FAILURE = "FETCH_CANCELLATION_STATISTICS_FAILURE";
